import { axiosHrClient } from '../plugins/axios'

const leave = {
  namespaced: true,

  actions: {
    getSystemMenus(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrportal/employees/${guid}/menusystems/2/programcatelogs/119`
          )
          const list = res.data.data.map(item => {
            const obj = {}
            obj.title = item.menuInSystemFullNameTha
            obj.menus = item.data.map(subItem => {
              return {
                name: subItem.menuInSystemFullNameTha,
                programItemMenuID: subItem.programItemMenuID,
                itemPath: subItem.menuInSystemPath,
                otherSystem: subItem.otherSystem
              }
            })
            return obj
          })
          resolve(list)
        } catch (e) {
          reject(e)
        }
      })
    },

    getStaffSystemMenus() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            '/hrportal/self/catelogroles/119/programitemroles'
          )
          let list_obj = {}
          res.data.data.forEach(item => {
            if (!Array.isArray(list_obj[item.programCatelogFullNameTha]))
              list_obj[item.programCatelogFullNameTha] = []
            list_obj[item.programCatelogFullNameTha].push({
              name: item.programItemFullNameTha,
              programItemMenuID: item.programItemMenuID,
              itemPath: item.programItemPath,
              otherSystem: item.otherSystem
            })
          })
          const list = []
          for (let key in list_obj) {
            list.push({
              title: key,
              menus: list_obj[key]
            })
          }
          resolve(list)
        } catch (e) {
          reject(e)
        }
      })
    },

    getAll(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/calendars/employees/${payload.employee}/year/${payload.year}/month/${payload.month}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getFormTypeList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrleave/leavetypeeform`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getTypeStudy() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrleave/leavetypestudy`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getFormStatusList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrleave/leavestatuseform`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getFormSickList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrreference/leavereason`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeaveStat(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `hrportal/leavestat/employees/${payload}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeaveGroup(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/leavegroup/employees/${payload}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeaveDocumentDownload(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/reporteform/employees/${payload.guid}/leaveorders/${payload.leaveOrderID}`,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getAttachedDocumentDownload(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/download/leaveorders/${payload.leaveOrderID}/filename/${payload.docFileName}`,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeaveTimeline(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/leaveapproveprocess/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getInfoByLeaveOrderID(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/sickbussdeliver/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}/leavetype/${payload.leaveType}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getApproveStatusList(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/leaveapprovestatus/leaveorders/${payload.leaveOrderId}/approveNumber/${payload.approveNumber}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getRelaxInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/relax/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getOrdainInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/ordain/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}/leavetype/${payload.leaveType}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getHutchInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/hutch/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getSoldierInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/soldier/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getStudyInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/study/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getMarriedInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/married/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getHelpWifeInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/helpwife/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getCancelInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrleave/cancel/employees/${payload.employeeId}/leaveorders/${payload.leaveOrderId}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postSearchPending(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/checkstatusleave/employee`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postSearchCheck(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/checkstatusleave/staff`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postSearchCheckApprove(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/checkapprove/staff`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postChangeStatus(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/approvecheckstatus/staff`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCancelStatus(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/cancelcheckstatus/staff`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postSearchApproval(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/checkstatusleave/approval`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postSearchEmployeeByKeyword(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hr/keyword/employeessearch`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postComputeDay(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(`/hrleave/computeday`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postComputeDaySpecial(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/computedayspecial`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postComputeAllDay(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(`/hr/computeallday`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postComputeDayForCancel(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/computedayforcancel`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateCommonLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/sickbussdeliver/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateRelaxLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/relax/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateOrdainLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/ordain/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateHutchLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/hutch/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateSoldierLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/soldier/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateStudyLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/study/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateMarriedLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/married/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateHelpWifeLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/helpwife/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateCancelLeave(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/eform/cancel/addedit`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postCreateApproval(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/approvecheckstatus/approval`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    putCancelForm(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.put(
            `/hrleave/updatestatusform`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    reportLeaveMonth(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/employees/reportleavemonth`,
            payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    reportLeaveMonthAll(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/employees/reportleaveamount`,
            payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    reportLeaveMonthType(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/employees/reportleavedate`,
            payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    reportLeaveRelaxStat(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/hrleave/employees/reportrelaxstat`,
            payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default leave
